export default __webpack_public_path__ + "static/media/redesmob.828e7718.png";